<script setup lang="ts">

import type {InputField} from "~/constants/types/serviceInputs";


const inputStoreQuadrature:InputField = useStoreServiceInputs().value.quadrature

if (!inputStoreQuadrature.default_value) {
  inputStoreQuadrature.default_value = 50
}
function handleSelectQuadrature(key: number|string) {
  inputStoreQuadrature.default_value = key
}
function validateQuadrature(event: any) {
  if (event.target.value < 50) {
    inputStoreQuadrature.default_value= 50
  }
  if (event.target.value >= 10000) {
    inputStoreQuadrature.default_value = 10000
  }
}


</script>

<template>
  <div class="flex flex-col gap-3 mt-3">
    <div class="flex flex-row gap-4 justify-between">
      <div>
        <p class="order-service-form-text">{{ $t('order.body.services.quadrature') }}</p>
        <input
            v-model="inputStoreQuadrature.default_value"
            id="quadrature"
            class="mt-2 w-full  appearance-none border rounded-[6px] py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="number"
            placeholder="1"
            @blur="validateQuadrature"
        >
      </div>
    </div>
    <div class="flex flex-row gap-2">
      <p v-for="quadrat in inputStoreQuadrature.options" @click="handleSelectQuadrature(quadrat.key)"
           class="text-sm  appearance-none border rounded-2xl px-3 border-light focus:outline-none focus:shadow-outline cursor-pointer p-1 flex justify-center border-light "
           :class="inputStoreQuadrature.default_value==quadrat.key? 'bg-primary-green bg-opacity-5 border-primary-green' : 'border-neutral-light-gray'"
      >
        {{quadrat.option}}
      </p>
    </div>
  </div>

</template>

<style scoped>

</style>